
export const collapseSection = function(element, defaultHeight) {
	element.style.height = defaultHeight + 'px';
	element.setAttribute('data-collapsed', 'true');
};

export const expandSection = function(element, defaultHeight = 0) {
	const sectionHeight = defaultHeight || element.scrollHeight;
	element.style.maxHeight = '';
	element.style.height = defaultHeight ? sectionHeight : sectionHeight + 'px';
	element.setAttribute('data-collapsed', 'false');
};

export function collapsibleSection(_sel) {
	const collapsedSection = _sel;

	if (collapsedSection) {
		const defaultHeight = 300;
		const fullHeight = collapsedSection.scrollHeight;
		const readMoreButton = collapsedSection.nextElementSibling;

		if (fullHeight > defaultHeight) {
			collapsedSection.style.height = defaultHeight + 'px';
			readMoreButton.style.display = 'inline-block';
			collapsedSection.setAttribute('data-collapsed', 'true');

			readMoreButton.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopImmediatePropagation();

				const isCollapsed = collapsedSection.getAttribute('data-collapsed') === 'true';

				if (isCollapsed) {
					expandSection(collapsedSection);
					this.innerHTML = 'Read Less';
				} else {
					setTimeout(function() {
						collapseSection(collapsedSection, defaultHeight);
					}, 50);
					this.innerHTML = 'Read More';
				}
			}, false);
		} else {
			collapsedSection.style.height = 'auto';
			readMoreButton.style.display = 'none';
			collapsedSection.setAttribute('data-collapsed', 'false');
		}
	}
}
